import { createFileRoute, redirect } from '@tanstack/react-router';

// FPD-028 — drilldown stub. The reconciliation report's Section 2 rows render
// anchors to this path; the workspace's existing `?deposit={id}` selection
// is the bank-transaction detail surface today, so we redirect bookmarks /
// row-clicks there with the param threaded through.
export const Route = createFileRoute('/admin/finance/bank-transactions/$bankTransactionId')({
  beforeLoad: ({ params }: { params: { bankTransactionId: string } }) => {
    throw redirect({
      to: '/admin/finance/transactions',
      search: {
        status: 'all' as const,
        view: 'match' as const,
        deposit: params.bankTransactionId,
      },
    });
  },
});
